import {useContext, useEffect, useState} from "react";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
// @ts-ignore
import {ContractsDTO} from "../model/ContractsDTO.tsx";
// @ts-ignore
import editIcon from "../../img/edit.png";
// @ts-ignore
import deleteIcon from "../../img/delete.png";
// @ts-ignore
import TextInputWeex from "../elements/TextInputWeex";
import NumberInputWeex from "../elements/NumberInputWeex";
// @ts-ignore
import SelectWeex from "../elements/SelectWeex";
import {ContractDTO} from "../model/ContractDTO";
import {repeats} from "../ToDos"
// @ts-ignore
import {Modal} from "../Modal.tsx";
// @ts-ignore
import {SettingsCard} from "./SettingCard.tsx";
import {ProductsDTO} from "../model/ProductsDTO";
import {ProductDTO} from "../model/ProductDTO";
// @ts-ignore
import {uploadImage} from "../api/APIfunctions.tsx";

export default function Products(){
  const [contracts, setContracts] = useState<ContractsDTO>({});
  const [products, setProducts] = useState<ProductsDTO>({});
  const [addNewContract, setAddNewContract] = useState<boolean>(false);
  const [addNewProduct, setAddNewProduct] = useState<boolean>(false);
  const [contractInput, setContractInput] = useState<ContractDTO | null>(null);
  const [productInput, setProductInput] = useState<ProductDTO | null>(null);
  const [backendUrl, setBackendUrl] = useState({});
  const [loading, setLoading] = useState<boolean>(false);
  const {getProducts, getContracts, saveContract, saveProduct, enableContractForPayment, disableContractForPayment, disableProductForPayment, enableProductForPayment} = useContext(APIContext)

  useEffect(() => {
    getContracts().then((contracts) => {
      setContracts(contracts);
    });
    getProducts().then((products) => {
      setProducts(products);
    });
    setBackendUrl(localStorage.getItem("backendUrl"))
  }, []);

  function renderContract(contract: ContractDTO){
    return <SettingsCard onEdit={() => {
      setContractInput(contract);
      setAddNewContract(true);
    }} onDelete={null}>
      <h4>{contract.name}</h4>
      <label>Vertagstyp:</label><p>{repeats.find(e => e.value === contract.repeat).label}</p><br/>
      <label>Tickets:</label><p>{contract.tickets}</p><br/><br/>
      {contract.months && <div><label>Laufzeit in Monate:</label><p>{contract.months}</p><br/></div>}
      {contract.price && <div><label>Preis:</label><p>{contract.price}</p></div>}
      {contract.stripeId ? <button className={"secondarybutton"}
                                   onClick={() => disableContractForPayment(contract.id).then((e) => e && window.location.reload())}>
        Als Produkt entfernen
      </button> : <button className={"primarybutton"} disabled={!contract.price}
                          onClick={() => enableContractForPayment(contract.id).then((e) => e && window.location.reload())}>
        Als Produkt anbieten
      </button>}
    </SettingsCard>
  }

  function renderProduct(product: ProductDTO){
    return <SettingsCard onEdit={() => {
      setProductInput(product);
      setAddNewProduct(true);
    }} onDelete={null}>
      <h4>{product.name}</h4>
      <label>Beschreibung:</label>
      <p style={{whiteSpace: "break-spaces"}}>{product.description}</p><br/>
      {product.image && <img src={backendUrl+product.image} alt={"Product Image"} width={"100%"}/>}
      {product.price && <div><label>Preis:</label><p>{product.price}€</p></div>}
      {product.stripeId ? <button className={"secondarybutton"}
                                   onClick={() => disableProductForPayment(product.id).then((e) => e && window.location.reload())}>
        Vom Shop entfernen
      </button> : <button className={"primarybutton"} disabled={!product.price}
                          onClick={() => enableProductForPayment(product.id).then((e) => e && window.location.reload())}>
        Im Shop anbieten
      </button>}
    </SettingsCard>
  }

  function handleChangeContract(field: string, value: any){
    setContractInput({...contractInput, [field]: value});
  }

  function handleChangeProduct(field: string, value: any){
    setProductInput({...productInput, [field]: value});
  }

  useEffect(() => {
    if(contractInput?.repeat === "all_in"){
      handleChangeContract("tickets", -1)
    }
    else{
      if(contractInput?.tickets < 1){
        handleChangeContract("tickets", "")
      }
    }
  }, [contractInput?.repeat]);

  function submitContract(){
    saveContract(contractInput).then((e) => {
      if(e){
        window.location.reload()
      }
    })
  }

  function submitProduct(){
    saveProduct(productInput).then((e) => {
      if(e){
        window.location.reload()
      }
    })
  }

  function renderContractInput(){
    return <Modal
      actionP={submitContract}
      actionS={() => setAddNewContract(false)}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={contractInput?.name && contractInput?.tickets >= -1 && contractInput?.repeat}>
      <h2>Preis:</h2>
      <NumberInputWeex value={contractInput.price} onChange={e => handleChangeContract("price", e)}
                       placeholder={"Preis"}/>
    </Modal>
  }

  function renderProductInput(){
    return <Modal
      actionP={submitProduct}
      actionS={() => {
        setProductInput(null)
        setAddNewProduct(false)
      }}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={productInput?.name && productInput?.description && productInput?.price}>
      <div style={{display: "grid", gridTemplateColumns: "1fr 1fr"}}>
        <div className={"flex-column"}>
          <img className={"boxlogoBig"} style={{opacity: loading ? 0.5 : undefined}}
               src={productInput?.image ? productInput.image : backendUrl+"/uploads/default.png"}
               alt={"productImage"}/>
          <input type="file" name="photo" accept="image/*"
                 onChange={(e) => {
                   setLoading(true)
                   uploadImage(e.target.files[0], (e, a) => console.log(e + a)).then(response => {
                     handleChangeProduct("image", response.info);
                     setLoading(false)
                   });
                 }}/>
        </div>
        <div>
          <h2>Name:</h2>
          <TextInputWeex value={productInput?.name} onChange={e => handleChangeProduct("name", e.target.value)}
                         placeholder={"Name"}/>
          <h2>Beschreibung:</h2>
          <TextInputWeex value={productInput?.description}
                         rows={5}
                         onChange={e => handleChangeProduct("description", e.target.value)}
                         placeholder={"Beschreibung"}/>
          <h2>Preis:</h2>
          <NumberInputWeex value={productInput?.price} onChange={e => handleChangeProduct("price", e)}
                           placeholder={"Preis"} style={{display: "inline-block"}}/><label>€</label>
        </div>
      </div>
    </Modal>
  }

  return (<div style={{position: "relative", width: "100%", height: "100%"}}>
    {addNewProduct && renderProductInput()}
    <h3>Produkte</h3>
    <button className={"primarybutton"} onClick={() => setAddNewProduct(true)}>Neues Produkt</button>
    <br/>
    <div id={"course_types"} className={"news-container"}>
      {products.products?.map((product) => renderProduct(product))}
    </div>
    {addNewContract && renderContractInput()}
    <h3>Verträge</h3>
    {/*<button className={"primarybutton"} onClick={() => setAddNewContract(true)}>Neuer Vertrag</button>*/}
    <br/>
    <div id={"course_types"} className={"news-container"}>
      {contracts.contracts?.map((contract) => renderContract(contract))}
    </div>
  </div>);
}
